import { render, staticRenderFns } from "./ModalAddCommon.vue?vue&type=template&id=3e4e2b2a&"
import script from "./ModalAddCommon.vue?vue&type=script&lang=ts&"
export * from "./ModalAddCommon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports